import IndexBankDetailsPage from "../pages/settings/bankDetails/IndexBankDetailsPage.vue";
import CreateBankDetailsPage from "../pages/settings/bankDetails/CreateBankDetailsPage.vue";
import EditBankDetailsPage from "../pages/settings/bankDetails/EditBankDetailsPage.vue";
import IndexTariffsPage from "../pages/settings/tariffs/IndexTariffsPage.vue";
import AiTransactionsIndexPage from "../pages/settings/tariffs/AiTransactionsIndexPage.vue";
import IndexProjectUsersPage from "../pages/settings/access/users/IndexProjectUsersPage.vue";
import EditProjectUsersPage from "../pages/settings/access/users/EditProjectUsersPage.vue";
import CreateProjectUserPage from "../pages/settings/access/users/CreateProjectUsersPage.vue";
import BasicSettingsPage from "../pages/settings/basic/BasicSettingsPage.vue";
import IndexSubscriptionsPage from "../pages/settings/subscriptions/IndexSubscriptionsPage.vue";
import ApiCredentialsPage from "../pages/settings/apiCredentials/IndexApiCredentialsPage.vue";
import CreateApiCredentialsPage from "../pages/settings/apiCredentials/CreateApiCredentialsPage.vue";
import EditApiCredentialsPage from "../pages/settings/apiCredentials/EditApiCredentialsPage.vue";
import ProfileEditPage from "../pages/settings/profile/ProfileEditPage.vue";

import i18n from '../i18n';

const basePath = "/app/projects/:projectUuid";

const settingsRoutes = [
    {
        path: `${basePath}/bank-details`,
        name: "IndexBankDetailsPage",
        component: IndexBankDetailsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexBankDetailsPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/bank-details/create`,
        name: "CreateBankDetailsPage",
        component: CreateBankDetailsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexBankDetailsPage"), linkName: "IndexBankDetailsPage" },
                    { name: i18n.global.t("pages.CreateBankDetailsPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/bank-details/:bankDetailUuid`,
        name: "EditBankDetailsPage",
        component: EditBankDetailsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexBankDetailsPage"), linkName: "IndexBankDetailsPage" },
                    { name: i18n.global.t("pages.EditBankDetailsPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/tariffs`,
        name: "IndexTariffsPage",
        component: IndexTariffsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexTariffsPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/tariffs/ai-transactions`,
        name: "AiTransactionsIndexPage",
        component: AiTransactionsIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexTariffsPage"), linkName: "IndexTariffsPage" },
                    { name: i18n.global.t("pages.AiTransactionsIndexPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/access/users`,
        name: "IndexProjectUsersPage",
        component: IndexProjectUsersPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexProjectUsersPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/access/users/:projectUserUuid`,
        name: "EditProjectUserPage",
        component: EditProjectUsersPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexProjectUsersPage"), linkName: "IndexProjectUsersPage" },
                    { name: i18n.global.t("pages.EditProjectUserPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/access/users/create`,
        name: "CreateProjectUserPage",
        component: CreateProjectUserPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexProjectUsersPage"), linkName: "IndexProjectUsersPage" },
                    { name: i18n.global.t("pages.CreateProjectUserPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/settings/basic`,
        name: "BasicSettingsPage",
        component: BasicSettingsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.BasicSettingsPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/settings/profile`,
        name: "ProfileEditPage",
        component: ProfileEditPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.ProfileEditPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/subscriptions`,
        name: "IndexSubscriptionsPage",
        component: IndexSubscriptionsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexSubscriptionsPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/api-credentials`,
        name: "ApiCredentialsPage",
        component: ApiCredentialsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.ApiCredentialsPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/api-credentials/create`,
        name: "CreateApiCredentialsPage",
        component: CreateApiCredentialsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.ApiCredentialsPage"), linkName: "ApiCredentialsPage" },
                    { name: i18n.global.t("pages.CreateApiCredentialsPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/api-credentials/:apiCredentialUuid/edit`,
        name: "EditApiCredentialsPage",
        component: EditApiCredentialsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.ApiCredentialsPage"), linkName: "ApiCredentialsPage" },
                    { name: i18n.global.t("pages.EditApiCredentialsPage") }
                ]
            }
        }
    }
]

export default settingsRoutes
